import { Coins, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import WaveAnimation from '../components/WaveAnimation';

export default function PricingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900 pt-24 relative overflow-hidden">
      <WaveAnimation />
      
      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Token-Based Learning
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Experience personalized learning with our flexible token-based system.
            Pay only for what you use and learn at your own pace.
          </p>
        </div>

        {/* Token-Based Pricing Section */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-purple-600/20 to-pink-600/20 rounded-2xl p-8 backdrop-blur-sm border border-purple-500/20">
            <div className="flex flex-col md:flex-row gap-8 items-center">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-4">
                  <Coins className="w-6 h-6 text-purple-400" />
                  <span className="text-purple-400 font-semibold">Token-Based Access</span>
                </div>
                <h2 className="text-3xl font-bold text-white mb-4">
                  Unlock the Ultimate Learning Experience
                </h2>
                <div className="space-y-4 mb-6">
                  <div className="flex items-start gap-3">
                    <Sparkles className="w-5 h-5 text-purple-400 mt-1" />
                    <p className="text-gray-300">
                      <span className="font-semibold text-white">All-Inclusive Access:</span> Use tokens to interact with our AI-powered assistant across all current and upcoming courses.
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <Sparkles className="w-5 h-5 text-purple-400 mt-1" />
                    <p className="text-gray-300">
                      <span className="font-semibold text-white">Pay-As-You-Learn:</span> Tokens are deducted only when you engage in learning sessions.
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <Sparkles className="w-5 h-5 text-purple-400 mt-1" />
                    <p className="text-gray-300">
                      <span className="font-semibold text-white">Flexible Renewals:</span> Top up tokens anytime to continue your personalized learning journey.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="md:w-72 w-full">
                <div className="bg-purple-900/50 rounded-xl p-6 backdrop-blur-sm">
                  <div className="text-center mb-4">
                    <div className="text-2xl font-bold text-white mb-2">100M Tokens</div>
                    <div className="text-3xl font-bold text-purple-400">BDT 30,000</div>
                  </div>
                  <button 
                    onClick={() => navigate('/checkout')}
                    className="w-full py-3 px-6 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-lg transition-colors"
                  >
                    Start Learning Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}